import useZustand from 'hooks/useZustand';

let requesting = 0;

const listeners = new Set();

export const incrementRequesting = () => {
  requesting += 1;
  notifyListeners();
  updateAppStore();
};

export const decrementRequesting = () => {
  requesting = Math.max(0, requesting - 1);
  notifyListeners();
  updateAppStore();
};

export const getRequesting = () => requesting;

export const subscribeToRequesting = callback => {
  listeners.add(callback);
  return () => listeners.delete(callback);
};

const notifyListeners = () => {
  listeners.forEach(callback => callback(requesting));
};

const updateAppStore = () => {
  const setRequestingStore = useZustand('app', 'setRequesting', false);
  setRequestingStore(requesting);
};
